module.exports = __webpack_public_path__ + "img/HM.1f58a232.png";